import { STORAGE_COACH_NICKNAME_DISMISSED_KEY, STORAGE_COACH_SAINT_DISMISSED_KEY } from '~/constants/storageKeys'

export default function () {
  const { isTempNickname, isWatvUser, userId } = useAuth()
  const { isShowProfilePopup } = useProfile()

  // 닫힘 여부를 "닫은 userId 목록"으로 저장 (계정별 구분).
  // localStorage라 서버로 전송되지 않으며, 다른 계정 로그인 시 자동으로 다시 노출된다.
  const nicknameDismissedIds = useLocalStorage<string[]>(STORAGE_COACH_NICKNAME_DISMISSED_KEY, [])
  const saintDismissedIds = useLocalStorage<string[]>(STORAGE_COACH_SAINT_DISMISSED_KEY, [])

  // userId를 평문으로 저장하지 않기 위한 단방향 해시(FNV-1a, salt 포함).
  // 멤버십(닫았는지) 확인만 하므로 복원 불필요 → 비가역으로 저장한다.
  function hashUserId(id: string): string {
    const salted = `hml-coach::${id}`
    let h = 0x811c9dc5
    for (let i = 0; i < salted.length; i++) {
      h ^= salted.charCodeAt(i)
      h = Math.imul(h, 0x01000193)
    }
    return (h >>> 0).toString(36)
  }

  const currentKey = computed(() => (userId.value != null ? hashUserId(String(userId.value)) : null))

  const nicknameDismissed = computed(
    () => currentKey.value != null && nicknameDismissedIds.value.includes(currentKey.value),
  )
  const saintDismissed = computed(
    () => currentKey.value != null && saintDismissedIds.value.includes(currentKey.value),
  )

  // 최초 가입 시 프로필 팝업 자동 노출 판단이 끝나기 전까지 헤더 말풍선(1번)을 띄우지 않기 위한 게이트.
  const coachReady = useState('coachReady', () => false)

  function markCoachReady() {
    coachReady.value = true
  }

  // 1번·2번 공통 노출 조건: 임시 닉네임이고, 현재 계정이 아직 닫지 않음
  const showNicknameCoach = computed(() => isTempNickname.value && !nicknameDismissed.value)

  // 1번(헤더): 준비 완료 후 + 프로필 팝업이 닫혀 있을 때만
  const showHeaderNicknameCoach = computed(
    () => coachReady.value && showNicknameCoach.value && !isShowProfilePopup.value,
  )

  // 2번(프로필 닉네임): 공통 조건 그대로
  const showProfileNicknameCoach = showNicknameCoach

  // 3번(성도 인증): 2번이 안 보이고, 미인증이고, 현재 계정이 아직 닫지 않았을 때
  const showSaintCoach = computed(
    () => !showNicknameCoach.value && !isWatvUser.value && !saintDismissed.value,
  )

  function dismissNicknameCoach() {
    const key = currentKey.value
    if (key != null && !nicknameDismissedIds.value.includes(key)) {
      nicknameDismissedIds.value = [...nicknameDismissedIds.value, key]
    }
  }

  function dismissSaintCoach() {
    const key = currentKey.value
    if (key != null && !saintDismissedIds.value.includes(key)) {
      saintDismissedIds.value = [...saintDismissedIds.value, key]
    }
  }

  return {
    showHeaderNicknameCoach,
    showProfileNicknameCoach,
    showSaintCoach,
    dismissNicknameCoach,
    dismissSaintCoach,
    markCoachReady,
  }
}
